<template>
  <div class="main bgc-fff c-333 fs-18 ff-as">
    <div class="banner p-r">
      <div class="banner-img bgs-cover"></div>
      <div class="banner-text p-a c-c m-a ta-c c-fff">
        <h1 class="m-0 fs-50">Electrical</h1>
        <div class="c-ddd lh-15 fs-26"></div>
      </div>
    </div>

    <section class="area-1 pl-60 pr-60 ta-c">
      <div class="m-a c-59 lh-15">
        Electric tools have been the key to enhancing productivity across industries. Committed to new energy, here at
        FJDynamics, we have been making consistent investments in energy management and the R&D of new power tools. The
        goal of our efforts remains the same — to boost people's efficiency with tools they love to use.
      </div>
    </section>

    <section class="area-3 product-mod pl-60 pr-60">
      <h2 class="m-0 fs-40 c-26 ta-c fw-500">— Electrical —</h2>
      <ul class="d-f jc-c ta-c">
        <li>
          <nuxt-link class="li-a" to="/product/lawnmower">
            <h3 class="">Lawnmower</h3>
            <i class="reveal"
              ><img
                class="lawnmower-img"
                width="100%"
                height="100%"
                alt="Lawnmower"
                src="@/assets/images/industry/Lawnmower.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </nuxt-link>
        </li>
        <li>
          <nuxt-link class="li-a" to="/product/powersec">
            <h3 class="">PowerSec</h3>
            <i class="reveal"
              ><img width="100%" height="100%" alt="PowerSec" src="@/assets/images/industry/PowerSec.png"
            /></i>
            <span class="more d-ib"><em class="va-m">Learn More</em><b class="d-ib bgs-cover va-m"></b></span>
          </nuxt-link>
        </li>
      </ul>
    </section>
    <!-- <section class="area-4">
        <div class="area-4-content d-f jc-sb">
          <div class="left-img"></div>
          <div class="right-content">
            <div class="d-f  ai-fs">
              <img alt="Innovation" src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23262626' stroke-linecap='round' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Cpath d='M17.3 21.374C17.3 12.33 20.434 5 24.298 5c1.898 0 3.618 1.768 4.879 4.639M18.38 28.5C10.564 23.98 5.794 17.595 7.726 14.243c.949-1.647 3.338-2.256 6.45-1.915M25.08 31.126c-7.817 4.522-15.719 5.47-17.65 2.117-.95-1.647-.281-4.025 1.57-6.554M30.7 26.626C30.7 35.67 27.566 43 23.702 43c-1.898 0-3.618-1.768-4.879-4.639M29.62 19.5c7.816 4.521 12.586 10.905 10.654 14.257-.949 1.647-3.338 2.256-6.45 1.915M22.92 16.874c7.817-4.522 15.719-5.47 17.65-2.117.95 1.647.281 4.025-1.57 6.554'/%3E%3C/g%3E%3C/svg%3E" />
             <div>
              <h3 >Innovation</h3>
              <p>Consistent efforts on pushing the boundaries in new energy.</p>
             </div>
            </div>

            <div class="d-f  ai-fs">
              <img alt="Inspiration" src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23262626' stroke-linecap='round' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Cpath d='M20 36.5L18.5 42c-.159.558.27 1.11.862 1.11L35.67 43c1.009 0 1.712-.98 1.371-1.908l-2.443-6.65a1.746 1.746 0 0 1-.109-.61v-.742c0-1.589.427-3.15 1.238-4.527l1.078-1.832A15.806 15.806 0 0 0 39 18.704v-1.203c0-3.586-1.455-7.024-4.046-9.56A10.377 10.377 0 0 0 27.696 5c-4.86 0-9.521 1.89-12.959 5.253l-.066.065c-1.847 1.807-3.359 5.378-3.359 7.935 0 1.209-.419 2.383-1.19 3.328l-2.721 3.342a1.776 1.776 0 0 0 .448 2.639l2.24 1.4c.512.318.829.863.85 1.455l.023 3.41a4 4 0 0 0 5.29 3.757l.248-.084c1.047-.35 3.475-1.09 5-2 1.209-.72 2.215-1.6 2.215-2.985V29.67M26.645 10.782v2.62M20.851 14.056l2.317 1.31M20.851 20.603l2.317-1.309M26.645 23.877v-2.619M32.44 20.603l-2.318-1.309M32.44 14.056l-2.318 1.31'/%3E%3C/g%3E%3C/svg%3E" />
             <div>
              <h3 >Inspiration</h3>
              <p>Continuous technical improvement on power electronics, auto pilot, and motor drive technologies.</p>
             </div>
            </div>

            <div class="d-f  ai-fs">
              <img alt="Environment " src="data:image/svg+xml,%3Csvg width='49' height='48' viewBox='0 0 49 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h48v48H0z'/%3E%3Cg stroke='%23262626' stroke-width='2'%3E%3Cpath d='M41.5 23.817C41.5 14.253 33.665 6.5 24 6.5S6.5 14.253 6.5 23.817c0 7.95 5.414 14.648 12.792 16.683' stroke-linecap='round'/%3E%3Cpath d='M31.292 8.424l-.63 4.78a6.697 6.697 0 0 1-7.148 5.803l-.28-.022a4.97 4.97 0 0 0-5.31 5.553 5.897 5.897 0 0 1-5.301 6.582l-4.179.393'/%3E%3C/g%3E%3Cg stroke='%23262626' stroke-width='2'%3E%3Cpath d='M28.921 37.139c1.367 2.998 4.827 4.306 7.73 2.92 2.627-1.253 2.77-3.15 4.346-5.379 1.575-2.228 4.053-3.728 2.704-4.595-2.893-1.86-7.622-3.402-11.352-1.621-3.73 1.78-4.794 5.676-3.428 8.675z' stroke-linejoin='round'/%3E%3Cpath d='M35.413 33.622c-3.636.447-6.854 2.686-9.652 6.718' stroke-linecap='round'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E" />
             <div>
              <h3 >Environment </h3>
              <p>Technologies for the human kind and the planet.</p>
             </div>
            </div>

            <div class="d-f  ai-fs">
              <img alt="Production" src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h48v48H0z'/%3E%3Cg transform='translate(5 7)' stroke='%23262626' stroke-width='2'%3E%3Cpath d='M3.095 14.248A16.105 16.105 0 0 0 3 16c0 5.438 2.713 10.243 6.859 13.134m14.552 1.928c5.622-2.02 9.786-7.098 10.485-13.228M30.237 4.61A15.95 15.95 0 0 0 19 0a15.94 15.94 0 0 0-7.854 2.056' stroke-linecap='round'/%3E%3Ccircle cx='5' cy='9' r='5'/%3E%3Ccircle cx='33' cy='9' r='5'/%3E%3Ccircle cx='19' cy='31' r='5'/%3E%3C/g%3E%3Ccircle stroke='%23262626' stroke-width='2' cx='24' cy='23' r='4'/%3E%3C/g%3E%3C/svg%3E" />
             <div>
              <h3 >Production</h3>
              <p>Sophisticated supply chain integration capability.</p>
             </div>
            </div>

            <div class="d-f  ai-fs">
              <img alt="Cost-saving" src="data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='none' d='M0 0h48v48H0z'/%3E%3Cg transform='translate(8 5.5)' stroke='%23262626'%3E%3Cg stroke-width='2'%3E%3Cpath d='M21.712 34.784H6.048C2.708 34.784 0 32.087 0 28.76a6 6 0 0 1 .076-.95l1.161-7.24C2.363 13.557 8.438 8.396 15.57 8.396h.642c7.132 0 13.207 5.16 14.333 12.175l.625 3.898M7.593 1.677l.001.008c.787 3.83 4.203 6.711 8.297 6.711 3.948 0 7.265-2.68 8.202-6.305.035-.135.067-.293.097-.473A1.39 1.39 0 0 0 22.818 0H8.963a1.399 1.399 0 0 0-1.37 1.677z'/%3E%3Cg stroke-linecap='round'%3E%3Cpath d='M11.238 14.757l3.137 5.33m6.049-5.33l-3.138 5.33M10.584 20.615h10.584M15.876 20.615v8.899M10.584 25.064h10.584'/%3E%3C/g%3E%3C/g%3E%3Cellipse stroke-width='2' cx='28.591' cy='31.622' rx='7.409' ry='7.378'/%3E%3Cg stroke-linecap='round' stroke-width='1.8'%3E%3Cpath d='M28.591 27.932v5.797'/%3E%3Cpath stroke-linejoin='round' d='M25.416 32.149l3.175 3.162 3.176-3.162'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E" />
             <div>
              <h3 >Cost-saving</h3>
              <p>Longer service life for electric products with lower operating and maintenance expenses.</p>
             </div>
            </div>

          </div>
        </div>
     </section> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    created() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  /* pc端样式 */
  @media screen and (min-width: 768px) {
    .main {
      margin-top: 3.958vw;
    }

    /* banner */
    .banner-img {
      /* padding-top: 26.0416vw; */
      padding-top: 3.6rem;
      background-position: top center;
      background-image: url('@/assets/images/business/p3-d.jpg');
    }
    .banner-text {
      display: block;
      /* width: 52.0833vw;
    top: 50%;
    left: 15.1vw;
    text-align: left;
    transform: translate(0, -50%); */
    }
    .banner-text h1 {
      margin-bottom: 15px;
    }

    /* area-1 */
    /* .area-1, */
    .area-2 {
      padding-top: 1rem;
    }
    .area-1 {
      padding: 0.48rem 18.75vw 0.8rem 18.75vw;
    }
    .area-1 li i {
      width: 5.2083vw;
      height: 5.2083vw;
      display: block;
      margin: 0 auto 15px;
    }
    .area-1 ul {
      padding: 5.625vw 20px 0;
    }

    /* area-2 / area-3 */
    .product-mod h2 {
      margin-bottom: 0.62rem;
    }
    .product-mod li {
      width: 5.92rem;
      height: 5.6rem;
      padding: 0.62rem 0.56rem 0.48rem;
      background-color: #fafafa;
      box-sizing: border-box;
      margin-right: 0.16rem;
    }
    .product-mod li:last-child {
      margin-right: 0;
    }
    .product-mod li i {
      display: block;
      margin-bottom: 0.16rem;
    }
    .product-mod li h3 {
      font-size: 0.28rem;
      font-weight: 500;
      color: #333333;
      /* line-height: 0.42rem; */
      margin-bottom: 0.16rem;
    }

    .product-mod li a {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 4.15rem;
    }

    .product-mod li h3 b {
      display: block;
    }
    .product-mod li span {
      font-size: 0.16rem;
      border: 1px solid #262626;
      margin: 0 auto;
      padding: 0.06rem 0.16rem 0.06rem 0.2rem;
    }
    .product-mod li span em {
      color: #262626;
    }
    .product-mod .more b {
      width: 12px;
      height: 12px;
      margin-left: 5px;
    }
    .product-mod li a:hover b {
      transform: translateX(6px);
    }
    .product-mod li a:hover img {
      transform: scale(1.05);
    }
    .product-mod li img {
      transition: transform 0.3s ease-out;
    }

    .area-3 {
      margin-bottom: 1.2rem;
    }

    .area-4 {
      width: 12rem;
      margin: 0 auto;
      padding-bottom: 1.2rem;
    }
    .area-4-content {
      flex-direction: row-reverse;
    }
    .left-img {
      width: 6.8rem;
      background-image: url('@/assets/images/industry/electric-b-img.png');
      background-repeat: no-repeat;
      background-size: contain;
      background-clip: border-box;
    }
    .right-content {
      margin-right: 0.24rem;
    }
    .right-content > div {
      margin-bottom: 0.27rem;
    }

    .right-content img {
      margin-right: 0.24rem;
    }
    .right-content h3 {
      height: 0.36rem;
      font-size: 0.24rem;
      color: #262626;
      line-height: 0.36rem;
      margin-bottom: 0.08rem;
    }
    .right-content p {
      height: 0.52rem;
      font-size: 0.18rem;
      color: #595959;
      line-height: 0.26rem;
    }
  }

  /*pc端样式 1440px ~  1650px*/
  @media screen and (max-width: 1650px) and (min-width: 1440px) {
    .fs-50 {
      font-size: 40px;
    }
    .fs-40 {
      font-size: 30px;
    }
    .fs-26 {
      font-size: 24px;
    }
  }

  /*pc端样式 1200px ~  1440px*/
  @media screen and (max-width: 1440px) and (min-width: 1200px) {
    .fs-50 {
      font-size: 30px;
    }
    .fs-40 {
      font-size: 26px;
    }
    .fs-26 {
      font-size: 20px;
    }
    .banner-text {
      width: 70%;
      top: 50%;
    }
    .area-1 li i {
      width: 80px;
      height: 80px;
    }
    .area-1 li span {
      font-size: 16px;
    }
    /* .product-mod li h3 {
    font-size: 20px;
  } */
    .product-mod li span {
      font-size: 14px;
    }
  }

  /*pc端样式 768px ~  1200px*/
  @media screen and (max-width: 1200px) and (min-width: 768px) {
    .fs-50 {
      font-size: 28px;
    }
    .fs-40 {
      font-size: 24px;
    }
    .fs-26 {
      font-size: 18px;
    }
    .fs-18 {
      font-size: 16px;
    }
    .banner-text {
      width: 90%;
      top: 50%;
    }
    .area-1 li i {
      width: 70px;
      height: 70px;
    }
    .area-1 li span {
      font-size: 16px;
    }

    .product-mod li span {
      font-size: 14px;
    }
  }
</style>
